export default __webpack_public_path__ + "static/media/alarmring.fdab3bcb.mp3";